import { useRef } from 'react';
import { FaChevronRight } from 'react-icons/fa';

/* eslint-disable-next-line */
type EmailOnlyFormsProps = {
  description: string;
  header: string;
  placeholder: string;
  handleActionButton: (emailInput: string) => void;
};

export function EmailOnlyForms(props: EmailOnlyFormsProps) {
  const { description, header, placeholder, handleActionButton } = props;

  const emailRef = useRef<any>(null);

  return (
    <div className="flex flex-row items-center justify-center">
      <div className="flex flex-col">
        <h4 className="text-header5 font-MuseoSans100 text-darkGreen font-bold">
          {header}
        </h4>
        <p className="text-caption font-MuseoSans w-60 sm:w-96">
          {description}
        </p>
        <div className="flex mt-2">
          <input
            className="w-60 sm:w-96 bg-inherit border border-black font-MuseoSans100 text-caption px-3 placeholder:text-primaryGray focus:outline-none"
            placeholder={placeholder}
            ref={emailRef}
          />
          <FaChevronRight
            className="ml-1 text-header5 bg-primaryGray text-white h-12 w-12 p-3 font-bold cursor-pointer"
            onClick={() => handleActionButton(emailRef?.current?.value)}
          />
        </div>
      </div>
    </div>
  );
}

export default EmailOnlyForms;
